import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.75,
			y: 4.75,
			width: 18.5,
			height: 14.5,
			rx: 3.25,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 2.5,
			y1: 9.75,
			x2: 21.5,
			y2: 9.75,
			stroke: "currentColor",
			strokeWidth: 2.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 5.5,
			y1: 14.6667,
			x2: 12.5,
			y2: 14.6667,
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgCard;
